<template>
  <div
    v-loading.fullscreen.lock="mainLoader"
    class="news-page body__content"
    element-loading-background="rgba(255, 255, 255, 0.8)"
  >
    <div class="search-section">
      <div class="container">
        <el-row class="mb-4">
          <el-col :sm="24">
            <h1>Articles</h1>
          </el-col>
        </el-row>

        <el-form
          id="searchForm"
          ref="searchForm"
          :model="search"
          @submit.native.prevent
        >
          <el-row class="search-row align-items-center">
            <el-col
              :sm="24"
              :md="12"
            >
              <el-form-item prop="keyword">
                <template slot="label">
                  <span class="hidden-sm-and-down">Keyword search</span>
                </template>
                <el-input
                  id="keyword"
                  v-model="search.keyword"
                  placeholder="Search by keywords"
                  auto-complete="no"
                  maxlength="255"
                  @keyup.enter.native="searchArticles"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col
              :sm="24"
              :md="12"
              :lg="12"
              class="d-flex mt-2"
            >
              <el-button
                type="text"
                class="reset-btn"
                @click="resetSearch"
              >
                Reset
              </el-button>
              <el-button
                type="primary"
                class="update-results-btn"
                @click="searchArticles"
              >
                Update results
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div
      v-if="showZeroData"
      :id="showZeroData ? 'main-content' : ''"
      class="zero-data text-center mt-5"
    >
      <div class="container">
        <el-row>
          <el-col :sm="24">
            <p>
              We could not find any news and features with your search criteria.
              Please update your search and try again.
            </p>
          </el-col>
        </el-row>
      </div>
    </div>

    <div
      v-if="articles.length"
      :id="articles.length ? 'main-content' : ''"
      class="results-section"
    >
      <div class="container">
        <div class="mt-4">
          <el-row>
            <news-card
              v-for="article in articles"
              :key="article.id"
              :article="article"
            />
          </el-row>
        </div>
      </div>
    </div>

    <div class="pagination-help-section">
      <div class="container">
        <el-button
          v-if="articles.length && !onLastPage"
          class="load-more-btn"
          size="medium"
          @click="fetchArticles"
        >
          Load more
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../../store";
import beWellCmsApi from "@/services/be-well-cms.api";
import NewsCard from "@/components/platform/news-features/news-card";
export default {
  name: "NewsAndFeatures",
  metaInfo: {
    title: "News & features",
  },
  components: {
    NewsCard,
  },
  data() {
    return {
      mainLoader: false,
      page: 1,
      perPage: 6,
      totalResults: 0,
      showZeroData: false,
      onLastPage: false,
      search: {
        keyword: "",
      },
      articles: [],
      articlesFilterOpen: false,
    };
  },
  created() {

    if (store.state.user.isLogged) {
      this.fetchArticles();
    }
  },
  methods: {

    resetSearch(isMobile) {
      if (isMobile) {
        this.closeArticlesFilter();
      }

      this.search = {
        keyword: "",
      };

      this.searchArticles();
    },

    searchArticles(isMobile) {
      if (isMobile) {
        this.closeArticlesFilter();
      }

      this.page = 1;
      this.articles = [];
      this.fetchArticles();
    },

    fetchArticles() {
      if (!this.mainLoader) {
        this.mainLoader = true;
      }

      let params = {
        page: this.page,
        limit: this.perPage,
        "filter[content:contains]":
          this.search.keyword && this.search.keyword != ""
            ? this.search.keyword
            : null,
      };

      beWellCmsApi
        .index("articles", params)
        .then((response) => {
          this.mainLoader = false;

          this.totalResults = response.data.meta.total;

          if (
            response.data.meta.current_page !== response.data.meta.last_page
          ) {
            this.onLastPage = false;
            this.page++;
          } else {
            this.onLastPage = true;
          }

          this.articles = this.articles.concat(response.data.data);

          this.showZeroData = this.articles.length > 0 ? false : true;
        })
        .catch(() => {
          this.mainLoader = false;
        });
    },
    openArticlesFilter() {
      this.articlesFilterOpen = true;
    },
    closeArticlesFilter() {
      this.articlesFilterOpen = false;
    },
    handleSortChange(sort) {
      this.search.type = sort.name;
      this.searchArticles();
    },
  },
};
</script>
